import { useState } from 'react';

const TIMEOUT = 800;

const useInputValidationDebouncer = (): [boolean, () => void] => {
  const [timer, setTimer] = useState<number>();

  const wait = () => {
    window.clearTimeout(timer);
    setTimer(window.setTimeout(() => setTimer(undefined), TIMEOUT));
  };

  return [!timer, wait];
};

export default useInputValidationDebouncer;
